import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Contact from '../components/Contact';

const Index = () => (
  <div>
    <Layout>
      <Banner/>
      <div className="container">
        <div className="row d-flex justify-content-center text-justify mb-50">
          <div className="col-lg-8 mt-sm-20">
            <p>
            Matlogica introduces a new scientific breakthrough to the field of simulation and optimization tasks. Our revolutionary approach allows to accelerate repetitive calculations and their sensitivities using <b>highly parallel vectorized software</b> and <b>AAD(automatic adjoint differentiation)</b>.
            </p>
            <p>
            Our innovative idea is to use Operator Overloading during the first run of the original function, to create its vectorized and multi-thread safe version. For details please read out short <a href="https://wilmott.com/aad-breaking-the-primal-barrier/">wilmott article</a>. Modern hardware is increasingly moving towards parallel calculations, but it can be challenging to write multi-thread safe and properly vectorized code. Our solution allows you to take full advantage of your hardware with minimal changes to your C++ code base while keeping the code clean and easy to understand.
            </p>
            <p>
            Our unique approach allowed us to obtain impressive <a href="https://arxiv.org/pdf/1901.04200.pdf">benchmarks</a> compared to other well known AAD tools. If you are interested in getting the best performance from your new or existing C++ code we can offer a quick proof-of-concept project to gage possible benefits we can bring to your organization.
            </p>
            <p align="center">
            <iframe width="567" height="320" src="https://www.youtube.com/embed/jHc62F4QmwQ" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </p>
            <Contact/>
          </div>
        </div>
      </div>
    </Layout>
  </div>
);

export default Index;
